import { Component } from 'react';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', gap: 16, padding: 24 }}>
          <p style={{ fontSize: 20, fontWeight: 700, color: '#2A1F1A', margin: 0 }}>Something went wrong</p>
          <p style={{ color: '#888', fontSize: 14, margin: 0 }}>Please refresh the page or try again.</p>
          <button
            onClick={() => this.setState({ hasError: false })}
            style={{ background: '#7A1F2B', color: '#fff', border: 'none', borderRadius: 999, padding: '10px 28px', cursor: 'pointer', fontWeight: 700, fontSize: 14 }}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
